// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'

const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const ReviewsRoute = ReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,ContactRoute: ContactRoute,ReviewsRoute: ReviewsRoute,ServicesRoute: ServicesRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)